'use client'

import { memo, useState } from 'react'

import { Button } from '@fp/ui-kit'

export const ExportCsvButton = memo(({ csvExportingHandle }: { csvExportingHandle?: () => Promise<void> }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (!csvExportingHandle) return

    setIsLoading(true)
    await csvExportingHandle()

    setIsLoading(false)
  }

  return (
    csvExportingHandle && (
      <Button onClick={handleClick} isLoading={isLoading} disabled={isLoading} className='ml-auto'>
        Export CSV
      </Button>
    )
  )
})
